import "./BusinessContact.module.css";
import Header from "@/reusable_sections/Header";
import BusinessContactForm from "./sections/BusinessContactForm";
import Footer from "@/reusable_sections/Footer";
export default function BusinessContactPage() {
  return <div>
      <Header />
      <BusinessContactForm />
      <Footer />
    </div>;
}